import type {SVGProps} from 'react'
import {useId} from 'react'
const GradientCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '')
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.28 8.0001H14.4C14.4 4.46548 11.5346 1.6001 8 1.6001V2.7201C10.9161 2.7201 13.28 5.08403 13.28 8.0001Z"
        fill="#2D2E2C"
      />
      <path
        d="M13.28 8.0001H14.4C14.4 4.46548 11.5346 1.6001 8 1.6001V2.7201C10.9161 2.7201 13.28 5.08403 13.28 8.0001Z"
        fill={`url(#${uid}paint0_linear_19314_46)`}
      />
      <path
        d="M13.28 8C13.28 10.9161 10.9161 13.28 8 13.28V14.4C11.5346 14.4 14.4 11.5346 14.4 8H13.28Z"
        fill="#2D2E2C"
      />
      <path
        d="M13.28 8C13.28 10.9161 10.9161 13.28 8 13.28V14.4C11.5346 14.4 14.4 11.5346 14.4 8H13.28Z"
        fill={`url(#${uid}paint1_linear_19314_46)`}
      />
      <path
        d="M2.72001 8H1.60001C1.60001 11.5346 4.46538 14.4 8.00001 14.4V13.28C5.08394 13.28 2.72001 10.9161 2.72001 8Z"
        fill="#2D2E2C"
      />
      <path
        d="M2.72001 8H1.60001C1.60001 11.5346 4.46538 14.4 8.00001 14.4V13.28C5.08394 13.28 2.72001 10.9161 2.72001 8Z"
        fill={`url(#${uid}paint2_linear_19314_46)`}
      />
      <path
        d="M8.00001 1.6001C4.46538 1.6001 1.60001 4.46548 1.60001 8.0001H2.72001C2.72001 5.08403 5.08394 2.7201 8.00001 2.7201V1.6001Z"
        fill="#2D2E2C"
      />
      <path
        d="M8.00001 1.6001C4.46538 1.6001 1.60001 4.46548 1.60001 8.0001H2.72001C2.72001 5.08403 5.08394 2.7201 8.00001 2.7201V1.6001Z"
        fill={`url(#${uid}paint3_linear_19314_46)`}
      />
      <defs>
        <linearGradient
          id={`${uid}paint0_linear_19314_46`}
          x1={8}
          y1={2.51438}
          x2={13.4857}
          y2={8.0001}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2085CE" />
          <stop offset={0.0498047} stopColor="#2387C7" />
          <stop offset={1} stopColor="#58B64A" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint1_linear_19314_46`}
          x1={13.4857}
          y1={8}
          x2={8}
          y2={13.4857}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58B64A" />
          <stop offset={1} stopColor="#DC9F1C" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint2_linear_19314_46`}
          x1={8.00001}
          y1={13.4857}
          x2={2.51429}
          y2={8}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DC9F1C" />
          <stop offset={1} stopColor="#E42922" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint3_linear_19314_46`}
          x1={2.51429}
          y1={8.0001}
          x2={8.00001}
          y2={2.51438}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E42922" />
          <stop offset={1} stopColor="#2085CE" />
        </linearGradient>
      </defs>
    </svg>
  )
}
export {GradientCircleIcon}
